import { Injectable } from '@angular/core';
import { NgxSpinnerService } from 'ngx-spinner';
import { BehaviorSubject, Observable } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LoaderService {
  private showLoader: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  public showLoader$: Observable<boolean> = this.showLoader.asObservable();
  constructor(private spinnerService: NgxSpinnerService) {
  } 
  public showSpinner(): void {
    this.spinnerService.show();

    // setTimeout(() => {
    //   this.spinnerService.hide();
    // }, 15000); // 15 seconds
  }

  public hideSpinner(): void {
    this.spinnerService.hide();
  }

  setloader(input:boolean) {
    this.showLoader.next(input);
  }
}
